import React, { useRef, useState } from 'react';
import { Button, Popover, Overlay, Form } from 'react-bootstrap';

const FilterDateRangeDropdown = ({ section, selected = {}, onChange }) => {
  const [open, setOpen] = useState(false);
  const [tempValue, setTempValue] = useState({});
  const target = useRef(null);

  const handleOpen = () => {
    setTempValue(selected || {}); // ← ustaw wartość tylko przy otwarciu
    setOpen(true);
  };

  const apply = () => {
    onChange(section.key, tempValue);
    setOpen(false);
  };

  const clear = () => {
    const cleared = { from: '', to: '' };
    setTempValue(cleared);
    onChange(section.key, cleared);
    setOpen(false);
  };

  const isActive = Boolean(selected?.from || selected?.to);

  return (
    <>
      <Button
        variant="outline-primary"
        size="sm"
        ref={target}
        onClick={handleOpen}
      >
        {section.label}
        {isActive && (
          <>
            {' ('}
            {selected?.from || '…'} – {selected?.to || '…'}
            {')'}
          </>
        )}
      </Button>

      <Overlay
        show={open}
        target={target.current}
        placement="bottom-start"
        rootClose
        onHide={() => setOpen(false)}
      >
        <Popover style={{ minWidth: '320px' }}>
          <Popover.Body>
            <Form.Group className="mb-3">
              <Form.Label>{section.labelFrom || 'Od'}</Form.Label>
              <Form.Control
                type="date"
                value={tempValue.from || ''}
                onChange={(e) =>
                  setTempValue((prev) => ({ ...prev, from: e.target.value }))
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{section.labelTo || 'Do'}</Form.Label>
              <Form.Control
                type="date"
                value={tempValue.to || ''}
                onChange={(e) =>
                  setTempValue((prev) => ({ ...prev, to: e.target.value }))
                }
              />
            </Form.Group>

            <div className="d-flex justify-content-between border-top pt-2 mt-2">
              <Button size="sm" variant="light" onClick={clear}>
                Wyczyść
              </Button>
              <Button size="sm" variant="primary" onClick={apply}>
                Zastosuj
              </Button>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </>
  );
};

export default FilterDateRangeDropdown;
